<template>
  <router-link v-if="post" :to="`/posts/${post.slug}`">
    <div class="archive-post" :class="{'large': large}">
      <img :src="post.images[0]" alt="">
      <div class="archive-post-text" :class="{'large': large}">
        <p class="text--dark" style="margin-bottom: 0px">{{ post.dateString }}</p>
        <h2 class="text--dark archive-post-title" style="margin-bottom: 20px">{{ post.title }}</h2>
        <p class="text--dark archive-post-summary" style="margin-bottom: 5px; white-space: pre-wrap;"  :class="{'large': large}">{{ post.plain }}</p>
        <p class="text--primary text-bold ">Läs mer</p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    post: {},
    large: false,
  }
}
</script>

<style scoped>

.archive-post {
  display: flex;
  flex-direction: column;
}
.archive-post.large {
  flex-direction: row;
}

.archive-post.large h2 {
  font-weight: bold;
}

.archive-post:hover .archive-post-text {
  opacity: 0.6;
}

.archive-post img {
  max-width: none;
  width: 100%;
  height: 320px;
  object-fit: cover;
  border-radius: 10px;
  transition: border-radius 200ms ease;
  /* opacity: 1 !important; */
}
.archive-post.large img {
  min-width: 50%;
  width: 50%;
  height: 440px;
}

.archive-post:hover img {
  border-radius: 20px;
}

.archive-post-text {
  margin-left: 0px;
  margin-top: 10px;
  transition: opacity 200ms ease;
}
.archive-post-text.large {
  margin-top: 0px;
  margin-left: 30px;
}

.archive-post-summary, .archive-post-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4; 
  -webkit-box-orient: vertical;
}

.archive-post-title {
  font-weight: bold;
  -webkit-line-clamp: 3;
  line-clamp: 3; 
}

.archive-post-summary.large {
  -webkit-line-clamp: 10;
  line-clamp: 10;
}

@media screen and (max-width: 1500px) {
  .archive-post.large img {
    height: 320px;
  }

  .archive-post-summary.large {
    -webkit-line-clamp: 6;
    line-clamp: 6;
  }
}

@media screen and (max-width: 1500px) {
  .archive-post.large img {
    height: 320px;
  }
}

@media screen and (max-width: 800px) {
  .archive-post.large {
    flex-direction: column;
  }

  .archive-post-text.large {
    margin-left: 0px;
    margin-top: 10px;
  }

  .archive-post-text.large h1 {
    font-size: 25px;
    font-weight: normal;
  }

  .archive-post img, .archive-post.large img {
    height: 280px;
    width: 100%;
  }

  .archive-post-summary.large {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4; 
    -webkit-box-orient: vertical;
  }
}

</style>